// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const navigateTo = (navigate, to, opts = {}) => {
  if (typeof to === 'string') {
    navigate(to, opts);
    return;
  }
  const { pathname, search, hash, state } = to || {};
  navigate({ pathname, search, hash }, { ...opts, state });
};

export const withRouter = (Wrapped) => {
  const WithRouter = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const listenersRef = useRef(new Set());

    useEffect(() => {
      listenersRef.current.forEach((fn) => fn(location, 'PUSH'));
    }, [location]);

    const history = {
      push: (to, state) => navigateTo(navigate, to, { state }),
      replace: (to, state) => navigateTo(navigate, to, { replace: true, state }),
      goBack: () => navigate(-1),
      goForward: () => navigate(1),
      go: (n) => navigate(n),
      get location() { return location; },
      listen: (fn) => {
        listenersRef.current.add(fn);
        return () => listenersRef.current.delete(fn);
      },
    };

    const match = {
      params, isExact: true, path: location.pathname, url: location.pathname,
    };

    return <Wrapped {...props} history={history} location={location} match={match} />;
  };
  WithRouter.displayName = `withRouter(${Wrapped.displayName || Wrapped.name || 'Component'})`;
  return WithRouter;
};
